import React, { useEffect, useMemo, useRef } from 'react';
import Block from './Block';
import type { ScheduleBlockCell } from './scheduleUtils';

type DayProps = {
  title: string;
  blocks: Record<number, ScheduleBlockCell>;
  editMode: boolean;
  onBlockSetSelected: (block: ScheduleBlockCell, selected: boolean) => void;
};

const Day: React.FC<DayProps> = ({ title, blocks, editMode, onBlockSetSelected }) => {
  const draggingRef = useRef(false);
  const paintToRef = useRef<boolean | null>(null);

  useEffect(() => {
    const endDrag = () => {
      draggingRef.current = false;
      paintToRef.current = null;
    };
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    return () => {
      window.removeEventListener('pointerup', endDrag);
      window.removeEventListener('pointercancel', endDrag);
    };
  }, []);

  const blockList = useMemo(
    () =>
      Object.keys(blocks)
        .map((k) => parseInt(k, 10))
        .sort((a, b) => a - b)
        .map((time) => blocks[time]),
    [blocks]
  );

  const handlePointerDown = (block: ScheduleBlockCell) => {
    if (!editMode) {
      return;
    }
    draggingRef.current = true;
    const next = !block.selected;
    paintToRef.current = next;
    onBlockSetSelected(block, next);
  };

  const handlePointerEnter = (block: ScheduleBlockCell) => {
    if (!editMode || !draggingRef.current || paintToRef.current === null) {
      return;
    }
    onBlockSetSelected(block, paintToRef.current);
  };

  return (
    <div className="schedule-day">
      <h5 style={{ textAlign: 'center' }}>{title}</h5>
      <div className="list-group">
        {blockList.map((block) => (
          <Block
            key={block.time}
            block={block}
            editMode={editMode}
            onBlockSetSelected={onBlockSetSelected}
            onPointerDownEdit={handlePointerDown}
            onPointerEnterEdit={handlePointerEnter}
          />
        ))}
      </div>
    </div>
  );
};

export default Day;
